import React from 'react';
import PropTypes from 'prop-types';

import {
	ErrorTextStyled,
	HelpTextStyled,
	SelectStyled,
	DropdownWrapperStyled,
} from './dropdownComponentStyles';

// Use for styled select-inputs
export const DropdownComponent = (props) => (
	<DropdownWrapperStyled className={props.className} labeled={!!props.label} tight={props.tight}>
		{props.label && <label htmlFor={props.id}>{props.label}{props.required && ' *'}</label>}
		<SelectStyled ref={props.inputRef} labeled={!!props.label} value={props.value} name={props.name} onChange={props.onChange} placeholder={props.placeholder} tight={props.tight} $invalid={props.invalid}>
			{props.placeholder && (
				<option value="" disabled={props.required && props.value !== ''}>{props.placeholder}</option>
			)}
			{props.options && props.options.map((option, idx) => (
				<option key={idx} value={option.value}>{option.display}</option>
			))}
		</SelectStyled>
		{props.helpText && <HelpTextStyled>
			<span className="pull-right">{props.helpText}</span>
		</HelpTextStyled>}
		{props.errorMessage && <ErrorTextStyled>
			{props.errorMessage}
		</ErrorTextStyled>}
	</DropdownWrapperStyled>
);

DropdownComponent.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	id: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			display: PropTypes.string,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			enabled: PropTypes.bool,
		})
	),
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onChange: PropTypes.func,
	name: PropTypes.string,
	placeholder: PropTypes.string,
	helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	errorMessage: PropTypes.string,
	required: PropTypes.bool,
	tight: PropTypes.bool,
	inputRef: PropTypes.func,
	invalid: PropTypes.bool, // when true show validation
};

DropdownComponent.defaultProps = {
	tight: false,
};
